import { c as _c } from "react/compiler-runtime";
import { BuildContextProvider } from '../../providers';
import { Renderer } from './renderer';
import type { Props } from './types';
export function Resolver(t0) {
  const $ = _c(5);
  const {
    entries,
    pageId
  } = t0;
  let t1;
  if ($[0] !== entries) {
    t1 = <Renderer entries={entries} />;
    $[0] = entries;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pageId || $[3] !== t1) {
    t2 = <BuildContextProvider pageId={pageId}>{t1}</BuildContextProvider>;
    $[2] = pageId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}